import type { Entity } from '@einhaus/project314-types';

/**
 * Generates a link to an entity page
 * @param entity The entity object or entity properties
 * @returns The URL path to the entity page
 */
export const getEntityLink = (entity: Entity | { entityId: number; entityType: string }): string => {
    if ('entityId' in entity) {
        // Handle objects with entityId/entityType properties
        return `/${entity.entityType.toLowerCase()}/${entity.entityId}/`;
    }

    // Handle Entity objects
    return `/${entity.entityType.toLowerCase()}/${entity.id}/`;
};

/**
 * Generates a link to an entity's option page
 * @param entity The entity object
 * @param optionId The option ID
 * @returns The URL path to the entity's option page
 */
export const getEntityOptionLink = (entity: Entity | { entityId: number; entityType: string }, optionId: number): string => {
    const entityLink = getEntityLink(entity);
    return `${entityLink}option/${optionId}/`;
};
